import ProcessRfqQuote from 'viewmodel/ProcessRfqQuoteViewModel';
import { DesBaseCollabAcc } from '../utils/des-base-collab-acc';

export default class DesProcessRfqQuote extends DesBaseCollabAcc {

    constructor() {
        console.log('DesProcessRfqQuote invoked');
        super(ProcessRfqQuote);
    }

    get collaborationspaceid() {
        return this.getAttribute('collaborationspaceid') || this.getAttribute('collaborationspace-id');
    }

    get rfqquoteid() {
        return this.getAttribute('rfqquoteid') || this.getAttribute('rfq-quote-id');
    }

    get status() {
        return this.getAttribute('status');
    }

    getProps() {
        return {
            collaborationspaceid: this.collaborationspaceid,
            rfqquoteid: this.rfqquoteid,
            status: this.status
        };
    }

    static get observedAttributes() {
        return [ ...DesBaseCollabAcc.observedAttributes, 'collaborationspaceid', 'collaborationspace-id', 'rfqquoteid', 'rfq-quote-id', 'status', 'status' ];
    }
}
if (!window.customElements.get('des-process-rfq-quote')) {
    window.customElements.define('des-process-rfq-quote', DesProcessRfqQuote);
}
